// Card from SaltUIFoundation: a surface with a 20pt continuous corner radius
// and an ambient shadow (black 15%, radius 10, no offset).

export const CARD_CHROME =
  "overflow-hidden rounded-[20px] bg-surface shadow-[0_0_20px_rgba(0,0,0,0.15)]";

export interface CardProps {
  /** Card(applyPadding:) — false when the content runs to the card's edges. */
  applyPadding?: boolean;
  className?: string;
  children: React.ReactNode;
}

export default function Card(props: CardProps) {
  const padding = props.applyPadding === false ? "" : "p-4";
  return <div className={`${CARD_CHROME} ${padding} ${props.className ?? ""}`}>
    {props.children}
  </div>
}
